import { makeStyles } from '@material-ui/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  invoice: {
    containerName: 'scheduledOrderInvoice',
    containerType: 'inline-size',
    boxSizing: 'border-box',
    margin: '0mm 6mm !important',
    display: 'none',
    gap: '0.5rem',
    flexDirection: 'column',
    alignItems: 'stretch',
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: '0.875rem',
    color: neutral.black,
    printColorAdjust: 'exact',
    padding: '0.5rem 0',
    '-webkit-print-color-adjust': 'exact !important',
    'color-adjust': 'exact !important',
    fontFamily: 'Inconsolata, monospace, sans-serif',
    '& *': {
      fontFamily: 'Inconsolata, monospace, sans-serif',
    },
    '& *[lang]': {
      hyphens: 'auto',
    },
    '@media print': {
      display: 'flex',
      '& [aria-label="scheduled-order-invoice"]': {
        pageBreakInside: 'avoid',
        pageBreakAfter: 'avoid',
        pageBreakBefore: 'avoid',
        breakBefore: 'avoid',
        breakInside: 'avoid',
        breakAfter: 'avoid',
      },
    },
  },

  header: {
    display: 'flex',
    gap: '0.5rem',
    flexDirection: 'column',
  },
  iconsContainer: {
    display: 'flex',
    gap: '0.25rem',
    alignItems: 'center',
  },
  rappiLogoContainer: {
    width: 'auto',
    height: 'inherit',
    maxWidth: '74px',
    margin: 0,
    '@container scheduledOrderInvoice (width >= 48mm)': {
      maxWidth: '88px',
    },
  },
  containerClient: {
    textAlign: 'center',
  },
  userName: {
    fontWeight: 700,
    fontSize: '1.5rem',
    lineHeight: '1.75rem',
  },
  orderId: {
    padding: '0.5rem 0',
    display: 'flex',
    columnGap: '0.75rem',
    flexWrap: 'wrap',
    justifyContent: 'center',
    fontWeight: 400,
    fontSize: '1.25rem',
    lineHeight: '1.25rem',
    border: `1px solid ${neutral.black}`,
  },
  moreInfoOrder: {
    display: 'flex',
    gap: '0.125rem',
    flexDirection: 'column',
    fontSize: '0.75rem',
    lineHeight: '0.875rem',
  },
  twoPartsToFlexWrap: {
    display: 'flex',
    columnGap: '0.25rem',
    flexWrap: 'wrap',
  },

  main: {
    display: 'flex',
    gap: '0.5rem',
    flexDirection: 'column',
  },
  titleOfDetails: {
    padding: '0.25rem 0.5rem',
    display: 'flex',
    columnGap: '0.5rem',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    fontWeight: 900,
    fontSize: '0.75rem',
    lineHeight: '0.875rem',
    border: `1px solid ${neutral.black}`,
    '@container scheduledOrderInvoice (width >= 48mm)': {
      fontSize: '0.875rem',
      lineHeight: '1rem',
    },
  },
  productList: {
    marginTop: '0.5rem',
    listStyleType: 'none',
  },
  product: {
    marginBottom: '0.25rem',
  },
  productDescription: {
    marginBottom: '0.125rem',
    display: 'flex',
    columnGap: '0.5rem',
    justifyContent: 'space-between',
    fontWeight: 'bold',
    '& > p:nth-child(2)': {
      flexGrow: 1,
    },
    '@container scheduledOrderInvoice (width >= 48mm)': {
      fontSize: '0.875rem',
      lineHeight: '1rem',
    },
  },
  toppingList: {
    marginLeft: '0.75rem',
    listStyleType: 'none',
  },
  toppingItem: {
    fontSize: '0.75rem',
    lineHeight: '0.875rem',
    display: 'flex',
    columnGap: '0.5rem',
    justifyContent: 'space-between',
    '& > p:first-child': {
      flexGrow: 1,
    },
  },
  toppingCategory: {
    fontWeight: 700,
    textTransform: 'uppercase',
    marginTop: '0.125rem',
  },

  checklistSection: {
    marginTop: '0.25rem',
    paddingTop: '0.5rem',
    paddingBottom: '0.25rem',
    display: 'block',
    borderTop: `1px solid ${neutral.black}`,
    borderBottom: `1px solid ${neutral.black}`,
    breakBefore: 'page',
  },
  checklistHeader: {
    marginBottom: '0.25rem',
    textAlign: 'center',
  },
  checklistTitle: {
    padding: '0.25rem 0.5rem',
    display: 'flex',
    columnGap: '0.5rem',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    fontWeight: 'bold',
    fontSize: '0.75rem',
    lineHeight: '0.875rem',
    border: `1px solid ${neutral.black}`,
  },
  checklist: {
    padding: '0.25rem 0',
    listStylePosition: 'inside',
    listStyleType: 'none',
  },
  checklistItemDescription: {
    display: 'flex',
    columnGap: '0.5rem',
    flexWrap: 'nowrap',
    justifyContent: 'stretch',
    '& > p[lang]': {
      flexGrow: 1,
    },
  },
  checklistToppings: {
    marginLeft: '1.25rem',
    listStylePosition: 'inside',
    listStyleType: '"\\025A1\\000A0"',
  },

  totalsSection: {
    marginTop: '0.5rem',
    borderTop: `1px solid ${neutral.black}`,
    paddingTop: '0.25rem',
    display: 'flex',
    justifyContent: 'space-between',
    fontWeight: 'bold',
    fontSize: '0.875rem',
    lineHeight: '1rem',
  },
});
